import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FeatureToggleService } from '@app/modules/feature-toggles/services/feature-toggle.service';
import { FiltersBarSelections } from '@app/services/filters.model';
import { FiltersService } from '@app/services/filters.service';
import { ZuiFiltersBarComponent } from '@zonar-ui/filter';
import { distinctUntilChanged } from 'rxjs';
import { Subject, takeUntil, filter } from 'rxjs';

@Component({
  selector: 'app-filters-bar-container',
  templateUrl: './filters-bar-container.component.html',
  styleUrls: ['./filters-bar-container.component.scss']
})
export class FiltersBarContainerComponent implements OnInit {
  @ViewChild(ZuiFiltersBarComponent) filterComponent: ZuiFiltersBarComponent;
  @Input() isDesktopView: boolean = true;
  filterList = [];
  private onDestroy$ = new Subject<void>();
  currentSelectedCompanyId: string;

  constructor(public filtersService: FiltersService, public featureToggleService: FeatureToggleService) {}

  ngOnInit(): void {
    this.featureToggleService
      .isFeatureEnabled('show-asset-properties-filter')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(showAssetProperties => {
        this.filterList = this.filtersService.getFilterList(this.isDesktopView, Boolean(showAssetProperties));
      });

    // register the reset function as a callback in filters service so it can clear display when company changes
    this.filtersService.setResetCallback(() => this.filterComponent.resetFilters());

    this.filtersService
      .getFiltersState()
      .pipe(
        filter(filters => filters.companyId != null),
        distinctUntilChanged((prev, curr) => prev.companyId === curr.companyId),
        takeUntil(this.onDestroy$)
      )
      .subscribe(filterState => {
        this.currentSelectedCompanyId = filterState.companyId;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  handleFiltersBarSelections(selections: FiltersBarSelections) {
    this.filtersService.setStateFromFiltersBar(selections);
  }
}
